import { VueExtension } from '../../utils/extensions/vue';
import DateTimePicker from './datetimepicker.jsx';
import './datetimepicker.scss';

VueExtension.WithInstall(DateTimePicker);

export default DateTimePicker;
